define((require) => {
    "use strict";

    const {debounce}                  = require("underscore");
    const Marionette                  = require("marionette");
    const Backbone                    = require("backbone");
    const ButtonIconCollectionView    = require("ui/experience/widgets/button/ButtonIconCollectionView");
    const ButtonIconCollection        = require("ui/experience/widgets/button/ButtonIconCollection");
    const ButtonWidgetHelper          = require("shared/ui/experience/widgets/button/ButtonWidgetHelper");
    const MaterialIcons               = require("ui/experience/widgets/button/MaterialIcons");
    const template                    = require("ui/experience/widgets/button/IconsSelectionView.tpl");

    const IconGroupModel = Backbone.Model.extend({

        defaults: {
            name: null,
            collection: null
        }

    });

    return Marionette.CompositeView.extend("IconsSelectionView", {

        className: "icons-selection-view",

        template,

        itemView: ButtonIconCollectionView,

        itemViewContainer: ".icons-group-container",

        _debouncedIconSearchInputChangeHandler: null, // set in initialize

        events: {
            "keypress @ui.iconSearchInput": "_debouncedIconSearchInputChangeHandler",
            "keyup @ui.iconSearchInput": "_debouncedIconSearchInputChangeHandler",
            "shown.bs.dropdown": "_iconDropdownShownHandler"
        },

        ui: {
            iconSearchInput: ".icon-search-input",
            dropdown: ".dropdown",
            allGroupsHiddenMessage: ".all-groups-hidden-message",
            selectedIconPreview: ".selected-icon-preview"
        },

        viewScope: {
            onButtonIconClick(icon) {
                const currentIcon = this.model.get("icon");
                let currentState = {};

                if (currentIcon) {
                    currentState = currentIcon.pick(["color", "placement", "size"]);
                }

                icon.set(currentState, {silent: true});
                this.model.set("icon", icon);
            }
        },

        initialize() {
            this._debouncedIconSearchInputChangeHandler = debounce(this._iconSearchInputChangeHandler.bind(this), 100);

            const entireCollection = new ButtonIconCollection(MaterialIcons.icons);
            const collection = new Backbone.Collection();

            MaterialIcons.groups.forEach((group) => {
                const icons = entireCollection.byGroup(group.data.id);
                const model = new IconGroupModel({
                    name: group.data.name,
                    collection: new ButtonIconCollection(icons)
                });

                collection.add(model);
            });

            this.collection = collection;
        },

        onShow() {
            this.updateSelectedIcon(this.model.get("icon"));
        },

        _iconDropdownShownHandler() {
            this.ui.iconSearchInput.focus();
        },

        _iconSearchInputChangeHandler() {
            const upperCaseSearchTerm = this.ui.iconSearchInput.val().toUpperCase();
            let amountOfHiddenIconGroupViews = 0;

            this.children.forEach((iconGroupView) => {
                const isHidden = iconGroupView.filterShownItemsAndReturnIsHidden(upperCaseSearchTerm);
                if (isHidden) {
                    amountOfHiddenIconGroupViews++;
                }
            });

            const areAnyGroupsShown = (amountOfHiddenIconGroupViews !== this.children.length);
            // hide the "all groups hidden" message if any groups are shown
            this.ui.allGroupsHiddenMessage.toggleClass("hidden", areAnyGroupsShown);
        },

        updateSelectedIcon(iconModel) {
            ButtonWidgetHelper.fetchIcon(iconModel).then((svg) => {
                if (this.ui.selectedIconPreview.attr) {
                    this.ui.selectedIconPreview.attr("title", iconModel.get("name"));
                    this.ui.selectedIconPreview.html(svg);
                }
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/button/IconsSelectionView.js